import React, { useState, useEffect } from "react";
import classNames from 'classnames/bind';

const DayNightToggle = ({ value, onChange, size, on, off, className, inside = false }) => {

  const [toggle, setToggle] = useState(value);

  const clickHandler = () => {
    const toggleValue = !toggle;
    setToggle(toggleValue);
    onChange(toggleValue);
  }


  useEffect(() => {
    setToggle(value)
  }, [value])

  return (
    <div className="day-night-toggle" data-state={toggle ? 'day' : 'night'}>
      <div className="day-night-toggle--wrapper" onClick={clickHandler}>
        <div className="day-night-toggle--knob" />
      </div>
    </div>
  );
}

export default DayNightToggle;

